import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, formatMXN } from "../lib/api";

export default function Cuenta() {
  const { user, loading, logout } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) api.get("/orders/me").then(({ data }) => setOrders(data));
  }, [user]);

  if (loading) return <div className="p-12">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="mx-auto max-w-5xl px-6 py-16" data-testid="account-page">
      <div className="flex items-end justify-between mb-12">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-[#A94438]">Mi cuenta</p>
          <h1 className="font-serif text-5xl tracking-tighter mt-2">Hola, {user.name}</h1>
          <p className="mt-1 text-[#5B605E]">{user.email}</p>
        </div>
        <button onClick={logout} className="btn-ghost" data-testid="logout">Salir</button>
      </div>

      <h2 className="font-serif text-3xl tracking-tighter mb-6">Tus pedidos</h2>
      {orders.length === 0 ? (
        <p className="text-[#5B605E]">Aún no tienes pedidos. <Link to="/catalogo" className="link-underline text-[#A94438]">Empieza a explorar</Link>.</p>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="border border-[#E8E3DA] bg-white p-6" data-testid={`order-${o.id}`}>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs uppercase tracking-wider text-[#5B605E]">Pedido #{o.id.slice(0, 8)}</p>
                  <p className="text-sm">{new Date(o.created_at).toLocaleString("es-MX")}</p>
                </div>
                <div className="text-right">
                  <p className="font-medium">{formatMXN(o.total)}</p>
                  <span className="text-xs uppercase px-2 py-1 bg-[#F2EFE9]">{o.status}</span>
                </div>
              </div>
              <div className="mt-4 flex flex-wrap gap-3">
                {o.items.slice(0, 4).map((it, i) => (
                  <img key={i} src={it.image} alt={it.name} className="h-16 w-12 object-cover" />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
